export default "__VITE_ASSET__BqlRnkKr__"